import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isUserLoggedIn } from 'utils/common';

// project import
// import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const userLogin = isUserLoggedIn();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userLogin) {
      navigate('login', { replace: true });
    }
  }, [navigate]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
